import React, { useEffect } from 'react'
import { User } from 'oidc-client-ts'
import { useNavigate } from 'react-router-dom'

import { getApplicationKeys } from 'services/api'
import { useGlobalContext } from 'providers/GlobalProvider'
import { useAuthContext } from 'providers/AuthProvider'
import { isSuccessStatus } from 'utils/functions/validations'

import Header from './Header'
import Container from './Container'

interface LayoutProps {
  children?: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { getUser } = useAuthContext()
  const navigate = useNavigate()
  const { setIdEmpresa, setIdSuscriptor, setUserProfile, setCompanyQuantity, setLastModifiedDate } = useGlobalContext()

  useEffect(() => {
    (async () => {
      const { status, data } = await getApplicationKeys()
      if (!isSuccessStatus(status)) {
        navigate('/error')
        return
      }
      const { companyId, subscriberId, quantity, lastModifiedDate } = data
      const user: User = await getUser()

      setIdEmpresa(companyId)
      setIdSuscriptor(subscriberId)
      setCompanyQuantity(quantity)
      setLastModifiedDate(lastModifiedDate)
      setUserProfile(user)
    })()
  }, [])

  return (
    <div>
      <Header />
      <Container>
        {children}
      </Container>
    </div>
  )
}

export default Layout
